module.exports = __webpack_public_path__ + "static/media/377SunsetAveNW_2018-06-11_69.039df258.jpg";